<template>
  <div class="flex-column" style="height: calc(100vh - 64px)">
    <div class="d-flex w-100" style="height: 5%">
      <div
        class="alerts-loading h-100 w-100"
        :class="
          loadingAlerts || alerts.length == 0
            ? 'bg-transparent'
            : 'bg-secondary'
        "
        style="margin: auto"
      >
        <div
          v-if="loadingAlerts"
          class="d-flex flex-grow-1 justify-center align-center h-100"
        >
          <v-progress-circular
            indeterminate
            :width="2"
            style="width: 3vh; height: 3vh"
          ></v-progress-circular>
          <p class="text-center pl-2" style="font-size: 2vh">
            Checando alertas...
          </p>
        </div>
        <AlertsPanel
          v-if="!loadingAlerts && alerts.length > 0"
          :alerts="alerts"
        ></AlertsPanel>
      </div>
    </div>

    <div class="d-flex w-100" style="height: 35%">
      <div class="w-50 pa-1">
        <v-card
          class="w-100 h-100 d-flex align-center pa-1"
          style="margin: auto"
        >
          <div
            class="d-flex flex-column justify-space-evenly align-start ml-4"
            style="width: 70%; height: 22.6vh; font-size: 2.7vh; line-height: 1"
          >
            <div class="d-flex align-center">
              <i class="wi wi-windy mr-2"></i>
              <b>Vento</b>:
              {{
                dadosClima?.station_data?.vel_vento &&
                (dadosClima.station_data.vel_vento * 3.6).toLocaleString(
                  "pt-BR",
                  {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  }
                )
              }}
              km/h
            </div>

            <div class="d-flex align-center">
              <i class="wi wi-humidity mr-2"></i>
              <b>Umidade</b>: {{ dadosClima?.station_data?.umidade }}%
            </div>

            <div
              class="d-flex align-center"
              v-if="dadosClima?.station_data?.taxa_chuva > 0"
            >
              <i class="wi wi-rain mr-2"></i>
              <b>Chuva</b>: {{ dadosClima?.station_data?.taxa_chuva }} mm/h
            </div>
            <div class="d-flex align-center" v-else>
              <i class="wi wi-rain mr-2"></i>
              Sem chuva no momento
            </div>

            <div class="d-flex align-center">
              <i
                class="wi wi-raindrop mr-2"
                v-if="dadosClima?.station_data?.chuva_dia > 0"
              ></i>
              <span v-if="dadosClima?.station_data?.chuva_dia > 0">
                <b>Choveu</b>: {{ dadosClima?.station_data?.chuva_dia }} mm hoje
              </span>
              <span v-else>
                <i class="wi wi-raindrop mr-2"></i>
                Sem chuva hoje
              </span>
            </div>
          </div>

          <div
            class="d-flex justify-center align-center"
            :style="[
              dadosClima?.forecast?.hourly?.[0]?.weather?.[0]?.main === 'Clear'
                ? 'background: linear-gradient(to bottom left, #4169E1, #87CEFA); color: #fff;'
                : dadosClima?.forecast?.hourly?.[0]?.weather?.[0]?.main ===
                  'Clouds'
                ? 'background: linear-gradient(to bottom left, #546E7A, #B0BEC5); color: #fff;'
                : dadosClima?.forecast?.hourly?.[0]?.weather?.[0]?.main ===
                  'Drizzle'
                ? 'background: linear-gradient(to bottom left, #01579B, #9FA8DA); color: #fff;'
                : dadosClima?.forecast?.hourly?.[0]?.weather?.[0]?.main ===
                  'Thunderstorm'
                ? 'background: linear-gradient(to bottom left, #651FFF, #303F9F); color: #fff;'
                : dadosClima?.forecast?.hourly?.[0]?.weather?.[0]?.main ===
                  'Rain'
                ? 'background: linear-gradient(to bottom left, #1A237E, #3949AB); color: #fff;'
                : dadosClima?.forecast?.hourly?.[0]?.weather?.[0]?.main ===
                  'Snow'
                ? 'background: linear-gradient(to bottom left, #427dd9, #90CAF9); color: #000;'
                : 'background: linear-gradient(to bottom left, #4169E1, #87CEFA); color: #fff;',
              'width: 70%; height: 100%; position: absolute; top: 0; right: 0; clip-path: polygon(60% 0, 100% 0, 100% 100%, 0% 100%);',
            ]"
          >
            <div
              class="d-flex flex-column align-center font-weight-bold"
              style="margin: 1vw 0 0 15vw"
            >
              <div class="d-flex align-center">
                <i
                  :class="
                    getWeatherIcon(
                      dadosClima?.forecast?.hourly?.[0]?.weather?.[0]?.icon
                    )
                  "
                  style="font-size: 12vh; margin-right: 10px"
                ></i>
                <span style="font-size: 8vh">
                  {{
                    dadosClima?.station_data?.temperatura
                      ? `${Math.round(dadosClima.station_data.temperatura)}°`
                      : "N/A"
                  }}
                  <span
                    style="
                      font-size: 0.6em;
                      vertical-align: super;
                      margin-left: -20px;
                    "
                    >C</span
                  >
                </span>
              </div>

              <span
                class="first-text-div"
                style="font-size: 3vh; margin-top: -10px; text-align: center"
              >
                {{
                  capitalizeWords(
                    dadosClima?.forecast?.hourly?.[0]?.weather?.[0]?.description
                  )
                }}
              </span>
              <span
                class="second-text-div text-center"
                style="font-size: 1.5vh"
              >
                Atualizado em {{ lastUpdated }}
              </span>
            </div>
          </div>
        </v-card>
      </div>

      <div class="w-50 pa-1">
        <ForecastPanel
          :dadosClima="dadosClima"
          :chart-data="chartData"
          :chart-labels="chartLabels"
        ></ForecastPanel>
      </div>
    </div>

    <div class="d-flex w-100 justify-space-evenly" style="height: 20%">
      <div
        v-for="(dispenser, index) in dados?.complexes?.[0]?.dispensers"
        :key="index"
        class="d-flex flex-column w-100 pa-1"
      >
        <v-card class="d-flex h-100">
          <div
            class="d-flex flex-column justify-space-evenly h-100"
            style="margin-left: 1vw"
          >
            <div class="d-flex align-center ga-3 w-100">
              <span class="text-black-50" style="font-size: 2.5vh">
                <v-icon class="mt-n1">mdi-waves</v-icon>
                {{ dispenser?.location || "Dados indisponíveis" }}
              </span>
            </div>

            <span
              class="font-weight-bold"
              style="font-size: 4vh"
              :style="{ color: !dispenser?.name ? '#FFFFFF' : '#424242' }"
            >
              {{ dispenser?.name || "Dados indisponíveis" }}
            </span>
            <span class="first-text" style="font-size: 2vh; font-weight: 500">
              <v-icon>mdi-calendar-month</v-icon>
              {{
                dispenser?.checkup_visits?.[0]?.visited_at
                  ? `${formatDate(
                      dispenser.checkup_visits[0].visited_at
                    )} - ${formatTime(dispenser.checkup_visits[0].visited_at)}`
                  : "Data indisponível"
              }}
            </span>

            <span class="first-text" style="font-size: 2vh">
              <v-icon>mdi-account</v-icon>
              {{
                dispenser?.checkup_visits?.[0]?.operator ||
                "Dados indisponíveis"
              }}
            </span>
          </div>

          <div
            class="d-flex justify-center align-center"
            :style="[
              dispenser?.checkup_visits?.[0]?.alert
                ? 'background: linear-gradient(to left, #B71C1C, #FF0000); color: white;'
                : !dispenser?.location ||
                  !dispenser?.name ||
                  !dispenser?.checkup_visits?.[0]
                ? 'background: linear-gradient(to left, #B71C1C, #FF0000); color: white;'
                : 'background: linear-gradient(to left, #2E7D32, #66BB6A); color: white;',
              'width: 50%; height: 100%; position: absolute; top: 0; right: 0; clip-path: polygon(60% 0, 100% 0, 100% 100%, 0% 100%);',
            ]"
          >
            <v-icon
              class="icon"
              style="font-size: 18vh; right: 0; position: absolute"
              color="white"
            >
              {{
                !dispenser?.location ||
                !dispenser?.name ||
                !dispenser?.checkup_visits?.[0]?.visited_at
                  ? "mdi-alert-circle-outline"
                  : dispenser?.checkup_visits?.[0]?.alert
                  ? "mdi-close-circle-outline"
                  : "mdi-check-circle-outline"
              }}
            </v-icon>
          </div>
        </v-card>
      </div>
    </div>

    <div class="d-flex w-100" style="height: 40%">
      <div class="w-50 pa-1">
        <AnalysisResultPanel
          title="DBO Saída"
          canvas-id="chartDbo"
          :chart-labels="analysisResults.labels"
          :chart-data="analysisResults.bdo"
          :limit-value="defaultDbo"
          :loading="loadingSampleResults"
        ></AnalysisResultPanel>
      </div>
      <div class="w-50 pa-1">
        <AnalysisResultPanel
          title="DQO Saída"
          canvas-id="chartDqo"
          :chart-labels="analysisResults.labels"
          :chart-data="analysisResults.dqo"
          :limit-value="defaultDqo"
          :loading="loadingSampleResults"
        ></AnalysisResultPanel>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import AlertsPanel from "./AlertsPanel.vue";
import ForecastPanel from "./ForecastPanel.vue";
import dayjs from "dayjs";
import AnalysisResultPanel from "./AnalysisResultPanel.vue";
import { defaultDbo, defaultDqo } from "@/consts";

export default {
  components: {
    AlertsPanel,
    ForecastPanel,
    AnalysisResultPanel,
  },
  data() {
    return {
      lastUpdated: new Date().toLocaleString(),
      chartData: [],
      chartLabels: [],
      dados: [],
      dadosClima: {},
      loadingAlerts: true,
      loadingSampleResults: true,
      alerts: [],
      analysisResults: {
        labels: [],
        bdo: [],
        dqo: [],
      },
      defaultDbo,
      defaultDqo,
    };
  },
  methods: {
    capitalizeWords(description) {
      if (!description) return "";
      return description
        .toLowerCase()
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    },
    getWeatherIcon(iconCode) {
      const iconMap = {
        "01d": "wi wi-day-sunny",
        "01n": "wi wi-night-clear",
        "02d": "wi wi-day-cloudy",
        "02n": "wi wi-night-alt-cloudy",
        "03d": "wi wi-cloud",
        "03n": "wi wi-cloud",
        "04d": "wi wi-cloudy",
        "04n": "wi wi-cloudy",
        "09d": "wi wi-showers",
        "09n": "wi wi-showers",
        "10d": "wi wi-day-rain",
        "10n": "wi wi-night-alt-rain",
        "11d": "wi wi-thunderstorm",
        "11n": "wi wi-thunderstorm",
        "13d": "wi wi-snow",
        "13n": "wi wi-snow",
        "50d": "wi wi-fog",
        "50n": "wi wi-fog",
      };
      return iconMap[iconCode] || "wi wi-na";
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },
    formatTime(dateString) {
      const date = new Date(dateString);
      return date.toLocaleTimeString("pt-BR", {
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    async fetchData() {
      try {
        const response = await axios.get("/lobato/data");
        this.dados = response.data;
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      }
    },
    async fetchWeatherData() {
      try {
        const response = await axios.get("/lobato/station/data");
        this.dadosClima = response.data;

        if (this.dadosClima?.forecast?.hourly) {
          const hourlySlice = this.dadosClima.forecast.hourly.slice(0, 6);
          this.chartData = hourlySlice.map((entry) => Math.round(entry.temp));
          this.chartLabels = hourlySlice.map((entry) => {
            const date = new Date(entry.dt * 1000);
            const hour = String(date.getHours()).padStart(2, "0");
            return `${hour}:00`;
          });
        } else {
          console.warn(
            "Dados de temperatura indisponíveis no forecast.hourly."
          );
        }
      } catch (error) {
        console.error("Erro ao buscar dados de clima:", error);
      }
    },
    async fetchAlertsData() {
      this.loadingAlerts = true;
      try {
        let res = await axios.get("/lobato/station/alerts");
        this.alerts = res.data;
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      } finally {
        this.loadingAlerts = false;
      }
    },
    async fetchSampleResults() {
      this.loadingSampleResults = true;
      try {
        let res = await axios.get("/lobato/analysis/history");
        res.data.forEach((result) => {
          this.analysisResults.labels.push(
            dayjs(result.collected_at).format("DD/MMM")
          );
          this.analysisResults.bdo.push(result.final_bdo);
          this.analysisResults.dqo.push(result.final_dqo);
        });
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      } finally {
        this.loadingSampleResults = false;
      }
    },
  },
  async beforeMount() {
    this.fetchSampleResults();
    await Promise.all([this.fetchData(), this.fetchWeatherData()]);
    this.fetchAlertsData();

    setInterval(() => {
      this.lastUpdated = new Date().toLocaleString();
      location.reload();
    }, 900000);
  },
};
</script>
